import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export type GetWorkshopVerificationRequestsFilter = operations['indexWorkshopVerifications']['parameters']['query'];

async function getWorkshopVerificationRequests(apiClient: ApiClient, filter: GetWorkshopVerificationRequestsFilter) {
  return apiClient.GET(`/op/v2/workshop-verification-request`, { params: { query: filter } });
}

export function useWorkshopVerificationRequestsQuery(filter: GetWorkshopVerificationRequestsFilter) {
  const toast = useToast();
  const apiClient = useApiClient();
  const navigate = useNavigate();

  const query = useQuery<InferFetchData<typeof getWorkshopVerificationRequests>, ApiError>({
    queryKey: getKey(filter),
    queryFn: () => throwOnError(getWorkshopVerificationRequests(apiClient, filter)),
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [navigate, query.error, query.isError, toast]);
  return query;
}

export function getKey(filter?: GetWorkshopVerificationRequestsFilter) {
  return ['WorkshopVerificationRequests', filter] as const satisfies QueryKey;
}

useWorkshopVerificationRequestsQuery.getKey = getKey;
